import axios from "axios"

function getLiveSessionV2({ id }) {
    return axios.get(`api/v2/live-sessions/${id}`)
}

function getCallV2({ id }) {
    return axios.get(`api/v2/live-sessions/${id}/call`)
}

function setSoundModeV2({ id }, data) {
    return axios.post(`api/v2/live-sessions/${id}/sound-mode`, data)
}

function makeCallV2({ id }, value) {
    return axios.post(`api/v2/live-sessions/${id}/call`, value)
}

function joinCallV2({ id }) {
    return axios.post(`api/v2/live-sessions/${id}/call/join`)
}

function leaveCallV2({ id }) {
    return axios.post(`api/v2/live-sessions/${id}/call/leave`)
}

function setVoiceRecordingActivityV2({ id }, data) {
    return axios.post(
        `api/v2/live-sessions/${id}/voice-recording-activity`,
        data
    )
}

function lowerHandsV2({ id }, data) {
    return axios.post(`api/v2/live-sessions/${id}/lower-hands`, data)
}

function raiseHandV2({ id }, data) {
    return axios.post(`api/v2/live-sessions/${id}/raise-hand`, data)
}

function getMetricsV2({ id }, params) {
    return axios.get(`api/v2/live-sessions/${id}/metrics`, { params })
}

function submitIssueReport({ id }, data) {
    return axios.post(`api/v2/live-sessions/${id}/issue-reports`, data)
}

export const liveServiceV2 = {
    getLiveSessionV2,
    getCallV2,
    setSoundModeV2,
    makeCallV2,
    joinCallV2,
    leaveCallV2,
    setVoiceRecordingActivityV2,
    lowerHandsV2,
    raiseHandV2,
    getMetricsV2,
    submitIssueReport,
}
